import React from 'react'
import BannerImage from '../../../assets/image/Bennar-img-5.avif'
import './style/banner.css'


function Banner({ setFilteredItems }) {

  

    return (
        <div className='border rounded-lg sm:m-1 md:ms-5 banner-margin-sm'>
            <div className='w-full h-80 rounded-lg banner-img'  style={{ backgroundImage: `url(${BannerImage})`, backgroundRepeat: 'no-repeat', backgroundPosition: 'center center', padding: '65px', backgroundSize: 'cover' }}>
                <div>
                    <span className='bg-gray-600  text-sm  p-3 text-black' style={{ letterSpacing: '2px' }}> NECKLACE</span>
                    <p className='text-black mt-5 text-lg'>Free Shipping On Over $50</p>
                    <p className='text-black mt-3 text-lg'>For the terms of the campaign, see the description page.</p>
                </div>
                <div className='relative' >
                    <span className='bg-black text-white text-lg p-3 ' style={{ position: 'absolute', bottom: -93, left: -5, letterSpacing: '2px' }} >See More Product</span>
                </div>
            </div>

        </div >




    )
}

export default Banner
